import { Routes } from '@angular/router';
import { OperationsComponent } from '@adm-web-app/modules/operations/list/operations.component';

export const operationsRoutes: Routes = [
  {
    path: '', component: OperationsComponent,
    data: {
      breadcrumb: 'List'
    }
  },
];
